export default [
  "/home",
  "/dashboard",
  "/requests/new-vendor",
  "/requests/detail",
  "/requests/list",
  "/requests/edit",
  "/groupAdmin/dashboard",
  "/approver/requests/ticket/detail",
  "/changePassword",
  "/orderWatcher/dashboard/recentOrder",
  "/orderWatcher/dashboard/report",
  "/event",
  //
  "/get-started",
  "/get-started/shop/1",
  "/get-started/shop/2",
  "/approver/request/shop",
  "/approver/request/product",
];
